// ReverseFilter
export default function ReverseFilter() {
	return function(items) {
		if (items) {
		  return items.slice().reverse();
		}
	  };
}